<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     :style="'background-image: url('+configData.company_banner+')'">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">
              <v-stepper v-model="e1">
                <div class="login-form d-flex align-items-center">
                    <form class="sign-in-sign-up-form w-100" ref="form" data-url="/user/confirm" action="store">
                        <div class="text-center mb-4">
                            <img :src="configData.company_logo?configData.company_logo:'/images/core.png'" alt=""
                                 class="img-fluid logo">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <h6 class="text-center mb-0">{{ $t('sign_up') }}</h6>
                            </div>
                        </div>
                        <el-steps :active="active" finish-status="success">
                            <el-step ></el-step>
                            <el-step ></el-step>
                            <el-step ></el-step>
                            <el-step ></el-step>
                        </el-steps>

                        <el-form v-if="active===1">
                            <div class="mt-3">
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <h6 class="text-center mb-0">{{ $t('buyer_or_supplier') }}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                   <div class="col-md-6">
                                        <div class="mb-primary">
                                            <div class="card card-with-shadow dashboard-widgets dashboard-icon-widget p-primary border-0 title_class_registration">
                                                <div class="icon-wrapper text-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layers">
                                                        <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                                        <polyline points="2 17 12 22 22 17"></polyline>
                                                        <polyline points="2 12 12 17 22 12"></polyline>
                                                    </svg>
                                                </div>
                                                <div class="widget-data mt-3 ml-0">
                                                    <p>{{ $t('buyer_registration_text') }}</p>
                                                    <h6 class="mt-3">{{ $t('view_buyer_invoice') }}</h6>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                    <div class="col-md-6">
                                       <div class="mb-primary">
                                            <div class="card card-with-shadow dashboard-widgets dashboard-icon-widget p-primary border-0 title_class_registration">
                                                <div class="icon-wrapper text-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layers">
                                                        <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                                                        <polyline points="2 17 12 22 22 17"></polyline>
                                                        <polyline points="2 12 12 17 22 12"></polyline>
                                                    </svg>
                                                </div>
                                                <div class="widget-data mt-3 ml-0">
                                                    <p>{{ $t('supplier_registration_text') }}</p>
                                                    <h6 class="mt-3">{{ $t('view_supplier_invoice') }}</h6>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                </div>
                            </div>
                        </el-form>

                        <el-form v-if="active===2">
                            <div class="mt-3">
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <h6 class="text-center mb-0">{{ $t('personal_information') }}</h6>
                                    </div>
                                </div>
                              <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_first_name">{{ $t('first_name') }}</label>
                                        <app-input type="text"
                                                v-model="user.first_name"
                                                :placeholder="$t('enter_first_name')"
                                                :required="true"
                                        />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_last_name">{{ $t('last_name') }}</label>
                                        <app-input type="text"
                                                v-model="user.last_name"
                                                :placeholder="$t('enter_last_name')"
                                                :required="true"
                                        />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_password">{{ $t('password') }}</label>
                                        <app-input type="password"
                                                v-model="user.password"
                                                :specialValidation="true"
                                                :placeholder="$t('enter_your_password')"
                                                :required="true"
                                        />
                                        <PasswordWarning/>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_password_confirmation">{{ $t('confirm_password') }}</label>
                                        <app-input type="password"
                                                same-as="user_password"
                                                v-model="user.password_confirmation"
                                                :placeholder="$t('confirm_password')"
                                                :required="true"
                                        />
                                    </div>

                                </div>
                                <div class="form-row" v-if="recaptchaEnable == 1">
                                    <div class="form-group col-12 px-0">
                                        <re-captcha :site-key="siteKey"></re-captcha>
                                    </div>
                                </div>
                            </div>
                        </el-form>

                        <el-form v-if="active===3">
                            <div class="mt-3">
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <h6 class="text-center mb-0">{{ $t('company_information') }}</h6>
                                    </div>
                                </div>
                              <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_first_name">{{ $t('first_name') }}</label>
                                        <app-input type="text"
                                                v-model="user.first_name"
                                                :placeholder="$t('enter_first_name')"
                                                :required="true"
                                        />
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_last_name">{{ $t('last_name') }}</label>
                                        <app-input type="text"
                                                v-model="user.last_name"
                                                :placeholder="$t('enter_last_name')"
                                                :required="true"
                                        />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_password">{{ $t('password') }}</label>
                                        <app-input type="password"
                                                v-model="user.password"
                                                :specialValidation="true"
                                                :placeholder="$t('enter_your_password')"
                                                :required="true"
                                        />
                                        <PasswordWarning/>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label for="user_password_confirmation">{{ $t('confirm_password') }}</label>
                                        <app-input type="password"
                                                same-as="user_password"
                                                v-model="user.password_confirmation"
                                                :placeholder="$t('confirm_password')"
                                                :required="true"
                                        />
                                    </div>

                                </div>
                                <div class="form-row" v-if="recaptchaEnable == 1">
                                    <div class="form-group col-12 px-0">
                                        <re-captcha :site-key="siteKey"></re-captcha>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                        <el-form v-if="active===4">
                            <div class="mt-3">
                                 <div class="form-row">
                                    <div class="form-group col-12">
                                        <h6 class="text-center mb-0">{{ $t('package_section') }}</h6>
                                        <div class="widget-data mt-3 ml-0 text-center">
                                            <h6 class="mt-3">{{ $t('three_months') }}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                        <div>
                                           <ul class="">
                                               <li class="card card-with-shadow dashboard-widgets dashboard-icon-widget p-primary border-0 text-center d-block" style="padding: 1.2rem!important;"> Bronze <li>
                                               <li class="nav-item d-block package_li"> burhan </li>
                                               <li class="nav-item d-block package_li"> one </li>
                                               <li class="nav-item d-block package_li"> two </li>
                                           </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>

                        <el-button class="btn btn-primary" style="margin-top: 12px;" @click="next">Next step</el-button>
                       
                        <!-- <div class="form-row">
                            <div class="form-group col-12">
                                <app-load-more :preloader="preloader"
                                               :label="$t('sign_up')"
                                               :class="{'disabled': !userInfo}"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div> -->
                        <div class="form-row">
                            <div class="col-12">
                                <p class="text-center mt-5">
                                    {{ $t('copyright_text') + configData.company_name }}
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
              </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import PasswordWarning from './PasswordWarning';
    import {AuthMixin} from "./Mixins/AuthMixin";

    export default {
        name: "Registration",
        mixins: [AuthMixin, ThemeMixin],
        components: {
            PasswordWarning
        },
        props: {
            userInfo: {},
            siteKey: String,
            recaptchaEnable: {},
        },
        data() {
            return {
                e1: 1,
                user: {},
                userData: {},
                active: 0
            }
        },
        created() {
            if (this.userInfo) {
                this.userData = JSON.parse(this.userInfo);
            }
        },
        methods: {
            submit() {
                let data = this.user;
                data.email = this.userData.email;
                data.invitation_token = this.userData.invitation_token;
                this.save(data);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                location.replace('/admin/users/login');
            },
            next() {
                if (this.active++ > 3) this.active = 0;
            }
        },
        mounted(){
          $('.sign-in-sign-up-form .btn-primary').removeClass('el-button el-button--default');
        },

    }
</script>
<style scoped>
.title_class_registration{
    display: block !important;
    flex-direction: initial !important;
    text-align: -webkit-center !important;
}
.package_li{
    padding: 10px;
    text-align: center;
    background: grey;
    margin-bottom: 8px;
    margin-top: 8px;
    color: black;
}
</style>
